import { Box, Grid } from "@mui/system";
import { useState } from "react";
import ModelAutoComplete from "../../actprep-ui/components/ModelAutoComplete";
import { MobileDatePicker } from "@mui/x-date-pickers-pro";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import api from "../../actprep-ui/utils/api";

export default function AssignProgramDialog({
  apiUrl,
  defaultValues,
  onSubmit,
  ...dialogProps
}) {
  const [program, setProgram] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      ...defaultValues,
      program_id: program.uuid,
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate?.format("YYYY-MM-DD") || null,
    };
    const response = await api.post(apiUrl, payload);
    if (!response.status == 200) {
      return;
    }
    if (onSubmit) {
      onSubmit();
    }
  };
  return (
    <Dialog {...dialogProps}>
      <Box component={"form"} onSubmit={handleSubmit}>
        <DialogTitle>Assign Program</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid size={12}>
              <ModelAutoComplete
                modelName={"Program"}
                label={"Program"}
                setValue={setProgram}
                value={program}
                required
              />
            </Grid>
            <Grid size={12}>
              <MobileDatePicker
                label="Start Date"
                value={startDate}
                onChange={(val) => setStartDate(val)}
                slotProps={{
                  textField: {
                    variant: "standard",
                    fullWidth: true,
                    required: true,
                  },
                }}
              />
            </Grid>
            <Grid size={12}>
              <MobileDatePicker
                label="End Date (Optional)"
                value={endDate}
                onChange={(val) => setEndDate(val)}
                slotProps={{
                  textField: {
                    variant: "standard",
                    fullWidth: true,
                  },
                }}
                minDate={startDate}
                disablePast
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit">Save</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
